import React, { Component } from "react";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { FormattedMessage } from "react-intl";
import "./EvaluateFooter.scss";
class Evaluate extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}
  componentDidUpdate(prevProps, prevState, snapshot) {}

  render() {
    return (
      <>
        <section className="evaluate-footer mt-2">
          <div className="bg-evaluate">
            <img
              src="/static/images/textures.png"
              data-src="/static/images/banner/evaluate-footer.png"
              alt=""
            />
          </div>
          <div className="container evaluate-title">
            <div
              className="section-header-2 animated fadeInDown"
              style={{ textAlign: "left" }}
              data-wow-offset={10}
              data-wow-duration="1.5s"
            >
              <div className="section-description">
                <p className="features-title">
                  <span>
                    <FormattedMessage id="evaluate-footer.a1" />
                    {/* <span style={{ fontWeight: 600 }}>ANOVATOR</span>{" "}
                    evaluate People’s Health */}
                  </span>
                </p>
              </div>
              <p style={{ fontWeight: 100 }}>
                <FormattedMessage id="evaluate-footer.a2" />
                {/* We are committed to improving people's health and helping people
                understand their bodies better. */}
              </p>
            </div>
          </div>
        </section>
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    language: state.app.language,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Evaluate)
);
